import { render, staticRenderFns } from "./LbaSwitchSimple.vue?vue&type=template&id=f07440b8"
import script from "./LbaSwitchSimple.vue?vue&type=script&lang=js"
export * from "./LbaSwitchSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports